// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ContentSection from "common/src/ContentSection.bs.js";

function WrappedSection(Props) {
  var children = Props.children;
  var title = Props.title;
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(ContentSection.make, {
              className: className + (
                Belt_Option.isSome(title) ? " pt-3" : ""
              ),
              children: null
            }, title !== undefined ? React.createElement("h4", {
                    className: "font-medium text-lg pb-2 text-accent"
                  }, title) : null, children);
}

var make = WrappedSection;

export {
  make ,
  
}
/* react Not a pure module */
